import { useEffect, useState } from "react";
import Link from "next/link";

import { ROUTE } from "@/route/app_routes";

const STORAGE_KEY = "stAcademy_cookieConsent";

const CookieConsentBanner = () => {

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const hasConsented = window.localStorage.getItem(STORAGE_KEY);
    if (!hasConsented) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    window.localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const dismiss = () => {
    // Not accepting doesn't block the strictly-necessary auth cookie (there's no consent choice
    // for that -- it's required for login to function), it just means we'll ask again next visit.
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="rbt-cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie notice">
      <p className="rbt-cookie-consent-text">
        We use a small number of cookies to keep you signed in and remember your preferences.
        We don&apos;t use cookies for advertising. Read our{" "}
        <Link href={ROUTE.privacy}>Privacy Policy</Link>.
      </p>
      <div className="rbt-cookie-consent-actions">
        <button type="button" className="rbt-btn btn-sm btn-border radius-round" onClick={dismiss}>
          <span>Dismiss</span>
        </button>
        <button type="button" className="rbt-btn btn-sm btn-gradient radius-round" onClick={accept}>
          <span>Got it</span>
        </button>
      </div>
    </div>
  );

};

export default CookieConsentBanner;
